// extracted by mini-css-extract-plugin
export var actions = "_ae-8";
export var arrow = "_ae-5";
export var card = "_ae-0";
export var cardWrapper = "_ae-9";
export var fieldName = "_ae-3";
export var newValue = "_ae-6";
export var oldValue = "_ae-4";
export var orangeGlowFade = "_ae-c";
export var productSection = "_ae-1";
export var scrollToBottom = "_ae-b";
export var scrollToBottomAnchor = "_ae-a";
export var scrollToBottomIcon = "_ae-d";
export var showAllButton = "_ae-7";
export var table = "_ae-2";